export default __webpack_public_path__ + "static/media/misc-books1-1440w.c65641a3.png";